import { render, staticRenderFns } from "./ProviderImage.vue?vue&type=template&id=e2101b44&"
import script from "./ProviderImage.vue?vue&type=script&lang=js&"
export * from "./ProviderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports